/* eslint-disable */
// @ts-nocheck
import { Category, MenuContent } from "../types/types"

export const categories: Array<Category> = [
  {
    "id": 1,
    "title": "KENDİM İÇİN",
    "level": 1
  },
  {
    "id": 2,
    "title": "ÇOCUK VE ANNE",
    "level": 1
  },
  {
    "id": 3,
    "title": "İŞİM İÇİN",
    "level": 1
  },
  {
    "id": 11,
    "title": "Ruh Sağlığım İçin",
    "parentId": 1,
    "level": 2
  },
  {
    "id": 12,
    "title": "Bedenim İçin",
    "parentId": 1,
    "level": 2
  },
  {
    "id": 13,
    "title": "Enerji Terapisi",
    "parentId": 1,
    "level": 2
  },
  {
    "id": 21,
    "title": "Pedagoji",
    "parentId": 2,
    "level": 2
  },
  {
    "id": 22,
    "title": "Gelişim",
    "parentId": 2,
    "level": 2
  },
  {
    "id": 23,
    "title": "Yeni Doğan",
    "parentId": 2,
    "level": 2
  },
  {
    "id": 31,
    "title": "Girişim ve Kobi",
    "parentId": 3,
    "level": 2
  },
  {
    "id": 32,
    "title": "Kariyerim İçin",
    "parentId": 3,
    "level": 2
  },
  {
    "id": 111,
    "title": "Psikoloji",
    "description": "Yaşamın zorluklarıyla başa çıkmak ve ruhsal sağlığınızı güçlendirmek için profesyonel psikolojik destek. Mutluluğunuzun peşinden gidin.",
    "metaTitle": "Online Psikolog",
    "metaDescription": "Yaşamın zorluklarıyla başa çıkmak ve ruhsal sağlığınızı güçlendirmek için profesyonel psikolojik destek. Mutluluğunuzun peşinden gidin.",
    "imgUrl": "/category-images/psikoloji.png",
    "parentId": 11,
    "slugLong": "/danismanliklar/kendim-icin/ruhunuza-iyi-gelecek/psikoloji/",
    "slug": "/online-psikolog/",
    "level": 3,
    "keywords": "Psikoloji, online psikoloji, online psikolog, psikolog"
  },
  {
    "id": 112,
    "title": "Aile Danışmanlığı",
    "description": "Aile içi ilişkilerinizi güçlendirin ve çatışmaları çözün. Uzman aile danışmanlarımızla daha mutlu ve huzurlu bir aile yaşamı için adım atın.",
    "metaTitle": "Aile Danışmanlığı",
    "metaDescription": "Aile içi ilişkilerinizi güçlendirin ve çatışmaları çözün. Uzman aile danışmanlarımızla daha mutlu ve huzurlu bir aile yaşamı için adım atın.",
    "imgUrl": "/category-images/aile-danismanligi.png",
    "parentId": 11,
    "slugLong": "/danismanliklar/kendim-icin/ruhunuza-iyi-gelecek/aile-danismanligi/",
    "slug": "/aile-danismanligi/",
    "level": 3,
    "keywords": "Aile Danışmanlığı, Aile Danışmanı, Online Aile Danışmanı, Online Aile Danışmanlığı"
  },
  {
    "id": 113,
    "title": "Cinsel Terapi",
    "description": "Cinsel hayatınızı olumsuz etkileyen vajinismus, erken boşalma, sertleşme bozukluğu, kadın ve erkekte cinsel istek bozukluğu, kadında uyarılma bozukluğu, ağrılı cinsellik, kadın ve erkekte orgazm bozukluğu gibi problemlerinizi aşmanızda size destek olması için Cinsel Terapistlerimizden online randevu alabilirsiniz.",
    "metaTitle": "Online Cinsel Terapi",
    "metaDescription": "Cinsel hayatınızı olumsuz etkileyen vajinismus, erken boşalma, sertleşme bozukluğu, kadın ve erkekte cinsel istek bozukluğu, kadında uyarılma bozukluğu, ağrılı cinsellik, kadın ve erkekte orgazm bozukluğu gibi problemlerinizi aşmanızda size destek olması için Cinsel Terapistlerimizden online randevu alabilirsiniz.",
    "imgUrl": "/category-images/cinsel-terapi.png",
    "parentId": 11,
    "slugLong": "/danismanliklar/kendim-icin/ruhunuza-iyi-gelecek/cinsel-terapi/",
    "slug": "/cinsel-terapi/",
    "level": 3,
    "keywords": "Cinsel terapi, online cinsel terapi"
  },
  {
    "id": 114,
    "title": "Bütünsel Terapi",
    "description": "Bütünsel terapi yöntemleriyle fiziksel, zihinsel ve ruhsal sağlığınızı bütünleştirin. Yaşam kalitenizi artırın.Detayları öğrenmek ve deneyimlemek için tıklayın.",
    "metaTitle": "Online Bütünsel Terapi",
    "metaDescription": "Bütünsel terapi yöntemleriyle fiziksel, zihinsel ve ruhsal sağlığınızı bütünleştirin. Yaşam kalitenizi artırın.Detayları öğrenmek ve deneyimlemek için tıklayın.",
    "imgUrl": "/category-images/butunsel-terapi.png",
    "parentId": 11,
    "slugLong": "/danismanliklar/kendim-icin/ruhunuza-iyi-gelecek/butunsel-terapi/",
    "slug": "/butunsel-terapi/",
    "level": 3,
    "keywords": "Bütünsel Terapi, Online Bütünsel Terapi, Bütünsel Terapi Uzmanı, Online Bütünsel Terapi Uzmanı"
  },
  {
    "id": 115,
    "title": "Yaşam Koçu",
    "description": "Hedeflerinize ulaşmanız için size rehberlik edecek profesyonel yaşam koçları. Motivasyon, hedef belirleme ve daha fazlası için tıklayın.",
    "metaTitle": "Online Yaşam Koçu",
    "metaDescription": "Hedeflerinize ulaşmanız için size rehberlik edecek profesyonel yaşam koçları. Motivasyon, hedef belirleme ve daha fazlası için tıklayın.",
    "imgUrl": "/category-images/yasam-kocu.png",
    "parentId": 11,
    "slugLong": "/danismanliklar/kendim-icin/ruhunuza-iyi-gelecek/yasam-kocu/",
    "slug": "/yasam-kocu/",
    "level": 3,
    "keywords": "Yaşam Koçu, Online Yaşam Koçu"
  },
  {
    "id": 121,
    "title": "Diyetisyen",
    "description": "Sağlığınızla ve kilonuzla ilgili ulaşmak istediğiniz hedeflerde size yol göstermesi ve sağlıklı bir yaşam tarzı benimsemeniz için size destek olması için Uzman Diyetisyenlerimizden online randevu alabilirsiniz.",
    "metaTitle": "Online Diyetisyen",
    "metaDescription": "Sağlığınızla ve kilonuzla ilgili ulaşmak istediğiniz hedeflerde size yol göstermesi ve sağlıklı bir yaşam tarzı benimsemeniz için size destek olması için Uzman Diyetisyenlerimizden online randevu alabilirsiniz.",
    "imgUrl": "/category-images/diyetisyen.png",
    "parentId": 12,
    "slugLong": "/danismanliklar/kendim-icin/goruntum-icin/diyetisyen/",
    "slug": "/diyetisyen/",
    "level": 3,
    "keywords": "Diyetisyen, Online Diyetisyen"
  },
  {
    "id": 122,
    "title": "Spor",
    "description": "Spor alışkanlıklarınızı değiştirmek, düzenlemek ve sürdürülebilir bir programı takip etmenize ve motivasyonunuzu ve disiplininizi kuvvetlendirmenize destek olması için Spor Uzmanlarımızdan online randevu alabilirsiniz.",
    "metaTitle": "Online Spor Antrenörü",
    "metaDescription": "Spor alışkanlıklarınızı değiştirmek, düzenlemek ve sürdürülebilir bir programı takip etmenize ve motivasyonunuzu ve disiplininizi kuvvetlendirmenize destek olması için Spor Uzmanlarımızdan online randevu alabilirsiniz.",
    "imgUrl": "/category-images/spor.png",
    "parentId": 12,
    "slugLong": "/danismanliklar/kendim-icin/goruntum-icin/spor/",
    "slug": "/spor/",
    "level": 3,
    "keywords": "Online Spor"
  },
  {
    "id": 123,
    "title": "Stil",
    "description": "Stilinizi geliştirmek ve nasıl giyinmenin size daha fazla yakışacağını öğrenmek için uzman stil danışmanlarımızdan randevu alabilir ve yani bir imaja sahip olabilirsiniz.",
    "metaTitle": "Online Stil Danışmanı",
    "metaDescription": "Stilinizi geliştirmek ve nasıl giyinmenin size daha fazla yakışacağını öğrenmek için uzman stil danışmanlarımızdan randevu alabilir ve yani bir imaja sahip olabilirsiniz.",
    "imgUrl": "/category-images/stil.png",
    "parentId": 12,
    "slugLong": "/danismanliklar/kendim-icin/goruntum-icin/stil/",
    "slug": "/stil/",
    "level": 3,
    "keywords": "Stil Danışmanı, Stil Danışmanlığı, Online Stil Danışmanı, Online Stil Danışmanlığı"
  },
  {
    "id": 602020,
    "title": "Fizyoterapi",
    "description": "Vücudunuzdaki ağrıların ve hareket kısıtlılıklarının farkındaysanız, kas ve eklem sağlığınızı geri kazanmanıza yardımcı olacak fizyoterapi hizmetlerimizden faydalanabilirsiniz. Uzman fizyoterapistlerimizden online randevu alarak, daha sağlıklı ve ağrısız bir yaşama adım atın.",
    "metaTitle": "Online Fizyoterapi",
    "metaDescription": "Vücudunuzdaki ağrıların ve hareket kısıtlılıklarının farkındaysanız, kas ve eklem sağlığınızı geri kazanmanıza yardımcı olacak fizyoterapi hizmetlerimizden faydalanabilirsiniz. Uzman fizyoterapistlerimizden online randevu alarak, daha sağlıklı ve ağrısız bir yaşama adım atın.",
    "imgUrl": "/category-images/fizyoterapi.png",
    "parentId": 12,
    "slugLong": "/danismanliklar/kendim-icin/goruntum-icin/fizyoterapi/",
    "slug": "/fizyoterapi/",
    "level": 3,
    "keywords": "fizyoterapi, online fizyoterapi, fizyoterapist, online fizyoterapist"
  },
  {
    "id": 131,
    "title": "Astroloji",
    "description": "Gök cisimlerinin konumları ve döngüleri ile dünyadaki fiziksel süreçler ve yaşam arasındaki eşzamanlılığın ışığında, Doğum haritası belirleme, Yıllık astroloji, Doğum saati belirleme ile hayatınızı yönlendirmenizde ve düzenlemenizde destek almak istiyorsanız Astrologlarımızdan online randevu alabilirsiniz. ‌",
    "metaTitle": "Online Astrolog",
    "metaDescription": "Gök cisimlerinin konumları ve döngüleri ile dünyadaki fiziksel süreçler ve yaşam arasındaki eşzamanlılığın ışığında, Doğum haritası belirleme, Yıllık astroloji, Doğum saati belirleme ile hayatınızı yönlendirmenizde ve düzenlemenizde destek almak istiyorsanız Astrologlarımızdan online randevu alabilirsiniz. ‌",
    "imgUrl": "/category-images/astroloji.png",
    "parentId": 13,
    "slugLong": "/danismanliklar/kendim-icin/enerji/astroloji/",
    "slug": "/astroloji/",
    "level": 3,
    "keywords": "Astroloji, Astrolog, Online Astroloji, Online Astrolog, Doğum Haritası Yorumlama"
  },
  {
    "id": 137,
    "title": "Numeroloji",
    "description": "Sayıların hayatınızdaki öneminin ve etkisinin farkındaysanız, kişiliğiniz, yetenekleriniz ve zayıflıklarınız ve gelecekte yaşamanız olası durumlarla ilgili sayıların yorumlarını anlamanızda destek olması için Numerologlarımızdan online randevu alabilirsiniz. ‌ ‌",
    "metaTitle": "Online Numeroloji",
    "metaDescription": "Sayıların hayatınızdaki öneminin ve etkisinin farkındaysanız, kişiliğiniz, yetenekleriniz ve zayıflıklarınız ve gelecekte yaşamanız olası durumlarla ilgili sayıların yorumlarını anlamanızda destek olması için Numerologlarımızdan online randevu alabilirsiniz. ‌ ‌",
    "imgUrl": "/category-images/numeroloji.png",
    "parentId": 13,
    "slugLong": "/danismanliklar/kendim-icin/enerji/numeroloji/",
    "slug": "/numeroloji/",
    "level": 3,
    "keywords": "Numeroloji, Online Numeroloji"
  },
  {
    "id": 132,
    "title": "NLP",
    "description": "NLP tekniği uzmanlarımızın yardımı ile ihtiyacını duyduğunuz motivasyonu yaratabilir, düşüncelerde sadeleşmeyi alışkanlık haline getirebilir, geçmişle olan negatif bağları koparıp geleceğinizi tasarlamaya başlayabilirsiniz.",
    "metaTitle": "Online NLP Uzmanı",
    "metaDescription": "NLP tekniği uzmanlarımızın yardımı ile ihtiyacını duyduğunuz motivasyonu yaratabilir, düşüncelerde sadeleşmeyi alışkanlık haline getirebilir, geçmişle olan negatif bağları koparıp geleceğinizi tasarlamaya başlayabilirsiniz.",
    "imgUrl": "/category-images/nlp.png",
    "parentId": 13,
    "slugLong": "/danismanliklar/kendim-icin/enerji/nlp/",
    "slug": "/nlp/",
    "level": 3,
    "keywords": "NLP Uzmanı, NLP Danışmanlığı, Online NLP Uzmanı, Online NLP Danışmanlığı"
  },
  {
    "id": 133,
    "title": "Reiki",
    "description": "Evrensel Yaşam enerjisinin aktarma alanında uzmanlaşmış Reiki uzmanlarımızdan randevu alarak, Öz benliğinizde ve bedeninizde gerçekleşmesini istediğiniz iyileşmeyi destekleyebilir, stresinizi azaltabilir ve derin bir rahatlama sağlayabilirsiniz.",
    "metaTitle": "Online Reiki Uzmanı",
    "metaDescription": "Evrensel Yaşam enerjisinin aktarma alanında uzmanlaşmış Reiki uzmanlarımızdan randevu alarak, Öz benliğinizde ve bedeninizde gerçekleşmesini istediğiniz iyileşmeyi destekleyebilir, stresinizi azaltabilir ve derin bir rahatlama sağlayabilirsiniz.",
    "imgUrl": "/category-images/reiki.png",
    "parentId": 13,
    "slugLong": "/danismanliklar/kendim-icin/enerji/reiki-enerji/",
    "slug": "/reiki-enerji/",
    "level": 3,
    "keywords": "Reiki, Online Reiki Uzmanı, Reiki Uzmanı, Online Reiki"
  },
  {
    "id": 134,
    "title": "Aile Dizimi",
    "description": "Hayatınızdaki tekrar eden negatif olayları ve üstesinden gelemediğiniz psikolojik sorunlarınızı ve travmalarınızı çözmek için Aile dizimini deneyebilir ve nesillerdir tekrar eden döngüleri kırarak daha özgür bir hayat yaşayabilirsiniz.",
    "metaTitle": "Online Aile Dizimi",
    "metaDescription": "Hayatınızdaki tekrar eden negatif olayları ve üstesinden gelemediğiniz psikolojik sorunlarınızı ve travmalarınızı çözmek için Aile dizimini deneyebilir ve nesillerdir tekrar eden döngüleri kırarak daha özgür bir hayat yaşayabilirsiniz.",
    "imgUrl": "/category-images/aile-dizilimi.png",
    "parentId": 13,
    "slugLong": "/danismanliklar/kendim-icin/enerji/ailedizimi/",
    "slug": "/ailedizimi/",
    "level": 3,
    "keywords": "Aile Dizimi, Online Aile Dizimi"
  },
  {
    "id": 135,
    "title": "Human Design",
    "description": "Doğu ve Batı Astrolojisi, I Chinq, Kabala, Çakra Sistemlerinin tamamını içeren Human design sistemi ile sadece size özel olan doğum tasarımınızı keşfederek hem kendinizi daha bütünsel anlayabilir hem de sevdiklerinizle olan ilişkinizi derinleştirebilirsiniz.",
    "metaTitle": "Online Human Design",
    "metaDescription": "Doğu ve Batı Astrolojisi, I Chinq, Kabala, Çakra Sistemlerinin tamamını içeren Human design sistemi ile sadece size özel olan doğum tasarımınızı keşfederek hem kendinizi daha bütünsel anlayabilir hem de sevdiklerinizle olan ilişkinizi derinleştirebilirsiniz.",
    "imgUrl": "/category-images/human-design.png",
    "parentId": 13,
    "slugLong": "/danismanliklar/kendim-icin/enerji/human-design/",
    "slug": "/human-design/",
    "level": 3,
    "keywords": "Human Design, Online Human Design"
  },
  {
    "id": 333,
    "title": "Kozmik Enerji",
    "description": "Kozmik Enerji uzmanlarımızdan randevu alarak, uzmanlarımızın kullandıkları kanallar vasıtasıyla ihtiyacını duyduğunuz şifayı kendinize evinizin konforunda ulaştırabilirsiniz.",
    "metaTitle": "Online Kozmik Enerji",
    "metaDescription": "Kozmik Enerji uzmanlarımızdan randevu alarak, uzmanlarımızın kullandıkları kanallar vasıtasıyla ihtiyacını duyduğunuz şifayı kendinize evinizin konforunda ulaştırabilirsiniz.",
    "imgUrl": "/category-images/kozmik-enerji.png",
    "parentId": 13,
    "slugLong": "/danismanliklar/kendim-icin/enerji/kozmik-enerji/",
    "slug": "/kozmik-enerji/",
    "level": 3,
    "keywords": "Kozmik Enerji, Online Kozmik Enerji, Kozmik Enerji Uzmanı"
  },
  {
    "id": 136,
    "title": "Theta Healing",
    "description": "Her şeyi yaratan, evrenin tek bileşeninin enerji seviyesinden şifa almak ve hayatınızı bu enerji ile yükseltmek için destek almak istiyorsanız Theta Healing uzmanlarımızdan online randevu alabilirsiniz.",
    "metaTitle": "Online Theta Healing",
    "metaDescription": "Her şeyi yaratan, evrenin tek bileşeninin enerji seviyesinden şifa almak ve hayatınızı bu enerji ile yükseltmek için destek almak istiyorsanız Theta Healing uzmanlarımızdan online randevu alabilirsiniz.",
    "imgUrl": "/category-images/theta-healing.png",
    "parentId": 13,
    "slugLong": "/danismanliklar/kendim-icin/enerji/theta-healing/",
    "slug": "/theta-healing/",
    "level": 3,
    "keywords": "Theta Healing, Online Theta Healing, Theta Healing Uzmanı, Theta Healing Uygulayıcısı"
  },
  {
    "id": 639181,
    "title": "Mindfulness",
    "description": "Mindfulness uzmanları ile stres yönetimi, odaklanma ve iç huzur için etkili teknikler öğrenin. Bilinçli farkındalık pratiği ile zihinsel ve duygusal dengeyi sağlayarak, yaşam kalitenizi artırın. Kişiye özel mindfulness seanslarımız hemen online randevu alabilirsiniz.",
    "metaTitle": "Online Mindfulness",
    "metaDescription": "Mindfulness uzmanları ile stres yönetimi, odaklanma ve iç huzur için etkili teknikler öğrenin. Bilinçli farkındalık pratiği ile zihinsel ve duygusal dengeyi sağlayarak, yaşam kalitenizi artırın. Kişiye özel mindfulness seanslarımız hemen online randevu alabilirsiniz.",
    "imgUrl": "/category-images/mindfulness.png",
    "parentId": 13,
    "slugLong": "/danismanliklar/kendim-icin/enerji/mindfulness/",
    "slug": "/mindfulness/",
    "level": 3,
    "keywords": "mindfulness, online mindfulness, Bilinçli Farkındalık"
  },
  {
    "id": 495139,
    "title": "JAAS",
    "description": "Hayatınızdaki enerji blokajlarını ve ruhsal engelleri fark ediyorsanız, JAAS yöntemi ile bu blokajları çözümleyerek ruhsal dengeyi ve iç huzuru bulmanıza yardımcı olabiliriz. Jean Adrienne Arınma Sistemi uzmanlarımızdan online randevu alarak, kendinizdeki bu değişimi başlatabilirsiniz.",
    "metaTitle": "Online JAAS",
    "metaDescription": "Hayatınızdaki enerji blokajlarını ve ruhsal engelleri fark ediyorsanız, JAAS yöntemi ile bu blokajları çözümleyerek ruhsal dengeyi ve iç huzuru bulmanıza yardımcı olabiliriz. Jean Adrienne Arınma Sistemi uzmanlarımızdan online randevu alarak, kendinizdeki bu değişimi başlatabilirsiniz.",
    "imgUrl": "/category-images/jaas.png",
    "parentId": 13,
    "slugLong": "/danismanliklar/kendim-icin/enerji/jaas/",
    "slug": "/jaas/",
    "level": 3,
    "keywords": "jaas, online jaas, Jean Adrienne Arınma Sistemi (JAAS)"
  },
  {
    "id": 211,
    "title": "Çocuk Psikoloğu",
    "description": "Çocuğunuzun duygusal ve sosyal gelişimini destekleyin. Uzman çocuk psikoloğumuzla güvenli ve destekleyici bir ortam yaratabilmek için bugün bizden destek alın.",
    "metaTitle": "Online Çocuk Psikoloğu",
    "metaDescription": "Çocuğunuzun duygusal ve sosyal gelişimini destekleyin. Uzman çocuk psikoloğumuzla güvenli ve destekleyici bir ortam yaratabilmek için bugün bizden destek alın.",
    "imgUrl": "/category-images/cocuk-psikologu.png",
    "parentId": 21,
    "slugLong": "/danismanliklar/kids/pedagoji/cocuk-psikologu/",
    "slug": "/cocuk-psikologu/",
    "level": 3,
    "keywords": "Çocuk Psikoloğu, Online Çocuk Psikoloğu, Pedagog, Online Pedagog"
  },
  {
    "id": 221,
    "title": "Çocuk Gelişimi",
    "description": "Çocuğunuzun her aşamasında yanınızdayız. Gelişimsel dönemlere uygun stratejiler ve aktivitelerle çocuğunuzun potansiyelini keşfedin.",
    "metaTitle": "Online Çocuk Gelişim Uzmanları",
    "metaDescription": "Çocuğunuzun her aşamasında yanınızdayız. Gelişimsel dönemlere uygun stratejiler ve aktivitelerle çocuğunuzun potansiyelini keşfedin.",
    "imgUrl": "/category-images/cocuk-gelisimi.png",
    "parentId": 22,
    "slugLong": "/danismanliklar/kids/gelisim-kids/cocuk-gelisim/",
    "slug": "/cocuk-gelisim/",
    "level": 3,
    "keywords": "Çocuk Gelişim, Çocuk Gelişim Uzmanı, Online Çocuk Gelişim, Online Çocuk Gelişim Uzmanı"
  },
  {
    "id": 222,
    "title": "Öğrenci Koçu",
    "description": "Eğitim yolculuğunuzda size destek olan öğrenci koçları. Motivasyon, zaman yönetimi ve sınav hazırlığı için profesyonel yardım almak için tıklayın. ",
    "metaTitle": "Online Öğrenci Koçu",
    "metaDescription": "Eğitim yolculuğunuzda size destek olan öğrenci koçları. Motivasyon, zaman yönetimi ve sınav hazırlığı için profesyonel yardım almak için tıklayın. ",
    "imgUrl": "/category-images/ogrenci-kocu.png",
    "parentId": 22,
    "slugLong": "/danismanliklar/kids/gelisim-kids/ogrenci-kocu/",
    "slug": "/ogrenci-kocu/",
    "level": 3,
    "keywords": "Öğrenci Koçu, Online Öğrenci Koçu"
  },
  {
    "id": 223,
    "title": "Rehberlik",
    "description": "Hayatınızdaki önemli kararlar için profesyonel rehberlik ve destek. Kariyer, eğitim ve kişisel gelişim yolculuğunuzda yanınızdayız.",
    "metaTitle": "Online Rehberlik Uzmanı",
    "metaDescription": "Hayatınızdaki önemli kararlar için profesyonel rehberlik ve destek. Kariyer, eğitim ve kişisel gelişim yolculuğunuzda yanınızdayız.",
    "imgUrl": "/category-images/rehberlik.png",
    "parentId": 22,
    "slugLong": "/danismanliklar/kids/gelisim-kids/rehberlik/",
    "slug": "/rehberlik/",
    "level": 3,
    "keywords": "Rehberlik Uzmanı, Online Rehberlik Uzmanı"
  },
  {
    "id": 224,
    "title": "Beslenme Uzmanları",
    "description": "Sağlıklı beslenme alışkanlıkları edinin ve yaşam kalitenizi artırın. Uzman diyetisyenlerimizle kişiye özel beslenme planları oluşturmak için tıklayın.",
    "metaTitle": "Online Beslenme Uzmanları",
    "metaDescription": "Sağlıklı beslenme alışkanlıkları edinin ve yaşam kalitenizi artırın. Uzman diyetisyenlerimizle kişiye özel beslenme planları oluşturmak için tıklayın.",
    "imgUrl": "/category-images/beslenme-uzmanlari.png",
    "parentId": 22,
    "slugLong": "/danismanliklar/kids/gelisim-kids/diyetisyen-kids/",
    "slug": "/diyetisyen-kids/",
    "level": 3,
    "keywords": "Çocuk Beslenme Uzmanları, Çocuk Diyetisyen, Çocuk Beslenme Uzmanı, Online Çocuk Beslenme Uzmanları, Online Çocuk Diyetisyen, Online Çocuk Beslenme Uzmanı"
  },
  {
    "id": 231,
    "title": "Uyku Danışmanlığı",
    "description": "\nBebeklerde uyku konusunda yaşadığınız zorluklara uzun vadeli ve dengeli çözümler arıyorsanız Uyku Danışmanlarımızdan online randevu alabilirsiniz.",
    "metaTitle": "Online Uyku Danışmanlığı",
    "metaDescription": "\nBebeklerde uyku konusunda yaşadığınız zorluklara uzun vadeli ve dengeli çözümler arıyorsanız Uyku Danışmanlarımızdan online randevu alabilirsiniz.",
    "imgUrl": "/category-images/uyku-danismanligi.png",
    "parentId": 23,
    "slugLong": "/danismanliklar/kids/yeni-dogan/uyku-danismanligi/",
    "slug": "/uyku-danismanligi/",
    "level": 3,
    "keywords": "Uyku Danışmanlığı, Online Uyku Danışmanlığı, Bebek Uyku Danışmanı, Online Bebek Uyku Danışmanı"
  },
  {
    "id": 232,
    "title": "Emzirme Danışmanlığı",
    "description": "Emzirme döneminde desteğe ihtiyaç duyuyorsanız, bu konuda özel eğitim almış danışmanlarımızdan online görüşme için randevu alabilirsiniz.",
    "metaTitle": "Online Emzirme Danışmanlığı",
    "metaDescription": "Emzirme döneminde desteğe ihtiyaç duyuyorsanız, bu konuda özel eğitim almış danışmanlarımızdan online görüşme için randevu alabilirsiniz.",
    "imgUrl": "/category-images/emzirme-danismanligi.png",
    "parentId": 23,
    "slugLong": "/danismanliklar/kids/gelisim-kids/emzirme-danismanligi/",
    "slug": "/emzirme-danismanligi/",
    "level": 3,
    "keywords": "Emzirme Danışmanlığı, Online Emzirme Danışmanlığı"
  },
  {
    "id": 233,
    "title": "Ebeveyn Danışmanlığı",
    "description": "Ebeveyn olarak çocuğunuzun ruhsal, sosyal ve duygusal sağlığını desteklemek ve gelişimlerini desteklemek ihtiyacı içindeyseniz Ebeveyn Danışmanlarımızdan online görüşme için randevu alabilirsiniz.",
    "metaTitle": "Online Ebeveyn Danışmanlığı",
    "metaDescription": "Ebeveyn olarak çocuğunuzun ruhsal, sosyal ve duygusal sağlığını desteklemek ve gelişimlerini desteklemek ihtiyacı içindeyseniz Ebeveyn Danışmanlarımızdan online görüşme için randevu alabilirsiniz.",
    "imgUrl": "/category-images/ebeveyn-danismanligi.png",
    "parentId": 23,
    "slugLong": "/danismanliklar/kids/yeni-dogan/ebeveyn-danismanligi/",
    "slug": "/ebeveyn-danismanligi/",
    "level": 3,
    "keywords": "Ebeveyn Danışmanı, Ebeveyn Danışmanlığı, Online Ebeveyn Danışmanı, Online Ebeveyn Danışmanlığı"
  },
  {
    "id": 311,
    "title": "Girişim",
    "description": "Girişim bilgisini, iş zekası ve tecrübeleriyle birleştirerek, kârlı bir ürün / marka oluşturmanız yolunda destek vermesi için Girişim Uzmanlarımızdan online randevu alabilirsiniz.",
    "metaTitle": "Online Girişim Danışmanı",
    "metaDescription": "Girişim bilgisini, iş zekası ve tecrübeleriyle birleştirerek, kârlı bir ürün / marka oluşturmanız yolunda destek vermesi için Girişim Uzmanlarımızdan online randevu alabilirsiniz.",
    "imgUrl": "/category-images/girisim.png",
    "parentId": 31,
    "slugLong": "/danismanliklar/isim-icin/girisim-ve-kobi/girisim/",
    "slug": "/girisim/",
    "level": 3,
    "keywords": "Girişim Danışmanı, Online Girişim Danışmanı"
  },
  {
    "id": 312,
    "title": "Sosyal Medya",
    "description": "Markanızı yönetirken değişen ve genişleyen dünya trendlerini takip etmeniz ve marka bilinirliğinizi arttırmak, güncel pazarlama faaliyetlerini geliştirmeniz yolunda destek vermesi için Sosyal Medya Uzmanlarımızdan online randevu alabilirsiniz.",
    "metaTitle": "Online Sosyal Medya Uzmanı",
    "metaDescription": "Markanızı yönetirken değişen ve genişleyen dünya trendlerini takip etmeniz ve marka bilinirliğinizi arttırmak, güncel pazarlama faaliyetlerini geliştirmeniz yolunda destek vermesi için Sosyal Medya Uzmanlarımızdan online randevu alabilirsiniz.",
    "imgUrl": "/category-images/sosyal-medya.png",
    "parentId": 31,
    "slugLong": "/danismanliklar/isim-icin/girisim-ve-kobi/sosyal-medya/",
    "slug": "/sosyal-medya/",
    "level": 3,
    "keywords": "Sosyal Medya Uzmanı"
  },
  {
    "id": 313,
    "title": "E-Ticaret",
    "description": "E-ticaret web sitenizle ön plana çıkmak mı istiyorsunuz? Trendleri öğrenmek ve işinizi yukarı çıkarmak için ihtiyaç duyduğunuz, aklınıza takılan her soruya cevap bulmak ve sürecinizi daha hızlı ve daha etkin hale getirmek için bu konuda uzman danışmanlarımızdan online görüşme için randevu alabilirsiniz.",
    "metaTitle": "Online E-Ticaret Danışmanı",
    "metaDescription": "E-ticaret web sitenizle ön plana çıkmak mı istiyorsunuz? Trendleri öğrenmek ve işinizi yukarı çıkarmak için ihtiyaç duyduğunuz, aklınıza takılan her soruya cevap bulmak ve sürecinizi daha hızlı ve daha etkin hale getirmek için bu konuda uzman danışmanlarımızdan online görüşme için randevu alabilirsiniz.",
    "imgUrl": "/category-images/e-ticaret.png",
    "parentId": 31,
    "slugLong": "/danismanliklar/isim-icin/girisim-ve-kobi/eticaret/",
    "slug": "/eticaret/",
    "level": 3,
    "keywords": "E-Ticaret Danışmanı, Online E-Ticaret Danışmanı"
  },
  {
    "id": 314,
    "title": "Muhasebe",
    "description": "Kendi muhasebeciniz yok mu veya başka bir görüş mü istiyorsunuz? Bireysel veya Kurumsal muhasebe konularında destek almak için Muhasebe Uzmanlarımızdan online görüşme için randevu alabilirsiniz.",
    "metaTitle": "Online Muhasebe Danışmanı",
    "metaDescription": "Kendi muhasebeciniz yok mu veya başka bir görüş mü istiyorsunuz? Bireysel veya Kurumsal muhasebe konularında destek almak için Muhasebe Uzmanlarımızdan online görüşme için randevu alabilirsiniz.",
    "imgUrl": "/category-images/muhasebe.png",
    "parentId": 31,
    "slugLong": "/danismanliklar/isim-icin/girisim-ve-kobi/muhasebe/",
    "slug": "/muhasebe/",
    "level": 3,
    "keywords": "Muhasebe Danışmanı, Online Muhasebe Danışmanı"
  },
  {
    "id": 315,
    "title": "Pazarlama",
    "description": "Mevcut pazarınızla ilgili durumu değerlendirmek, müşteri ve ürünü buluştururken doğru ve efektif adımların atılması yolunda destek vermesi için Pazarlama Uzmanlarımızdan online randevu alabilirsiniz.",
    "metaTitle": "Online Pazarlama Danışmanı",
    "metaDescription": "Mevcut pazarınızla ilgili durumu değerlendirmek, müşteri ve ürünü buluştururken doğru ve efektif adımların atılması yolunda destek vermesi için Pazarlama Uzmanlarımızdan online randevu alabilirsiniz.",
    "imgUrl": "/category-images/pazarlama.png",
    "parentId": 31,
    "slugLong": "/danismanliklar/isim-icin/girisim-ve-kobi/pazarlama/",
    "slug": "/pazarlama/",
    "level": 3,
    "keywords": "Pazarlama Danışmanı, Online Pazarlama Danışmanı"
  },
  {
    "id": 316,
    "title": "İş Geliştirme",
    "description": "İşinizi geliştirirken yeni müşteriler ve pazarlar bulunması, müşteri ihtiyaçlarını analiz ederek ürünün geliştirilmesi konularında destek vermesi için İş Geliştirme Uzmanlarımızdan online randevu alabilirsiniz.",
    "metaTitle": "Online İş Geliştirme",
    "metaDescription": "İşinizi geliştirirken yeni müşteriler ve pazarlar bulunması, müşteri ihtiyaçlarını analiz ederek ürünün geliştirilmesi konularında destek vermesi için İş Geliştirme Uzmanlarımızdan online randevu alabilirsiniz.",
    "imgUrl": "/category-images/is-gelistirme.png",
    "parentId": 31,
    "slugLong": "/danismanliklar/isim-icin/girisim-ve-kobi/is-gelistirme/",
    "slug": "/is-gelistirme/",
    "level": 3,
    "keywords": "İş Geliştirme Uzmanı"
  },
  {
    "id": 317,
    "title": "Satış",
    "description": "Ürününüz var ve satış konusunda destek arıyorsanız, Satış Danışmanlarımızdan online görüşme için randevu alabilir ve büyümenizi hızlandırabilirsiniz.",
    "metaTitle": "Online Satış Danışmanı",
    "metaDescription": "Ürününüz var ve satış konusunda destek arıyorsanız, Satış Danışmanlarımızdan online görüşme için randevu alabilir ve büyümenizi hızlandırabilirsiniz.",
    "imgUrl": "/category-images/satis.png",
    "parentId": 31,
    "slugLong": "/danismanliklar/isim-icin/girisim-ve-kobi/satis/",
    "slug": "/satis/",
    "level": 3,
    "keywords": "Online Satış Uzmanı, Satış Danışmanı"
  },
  {
    "id": 318,
    "title": "Tasarım",
    "description": "Tasarıma ürün olan her türlü konu için süreç danışmanlığı almak ve ürünün doğru mesajı vermesinde ve doğru konumlandırılması destek almak için Tasarım Danışmanlarımızdan online randevu alabilirsiniz.",
    "metaTitle": "Online Tasarım Danışmanı",
    "metaDescription": "Tasarıma ürün olan her türlü konu için süreç danışmanlığı almak ve ürünün doğru mesajı vermesinde ve doğru konumlandırılması destek almak için Tasarım Danışmanlarımızdan online randevu alabilirsiniz.",
    "imgUrl": "/category-images/tasarim.png",
    "parentId": 31,
    "slugLong": "/danismanliklar/isim-icin/girisim-ve-kobi/tasarim/",
    "slug": "/tasarim/",
    "level": 3,
    "keywords": "Tasarım Uzmanı"
  },
  {
    "id": 321,
    "title": "Profesyonel Koç",
    "description": "Potansiyelinizi açığa çıkarması, kişisel gelişimizi arttırması ve sizin hedeflerinize ulaşma yolunda doğru seçimler yapmanıza ve emin adımlar atmanıza destek vermesi için Profesyonel Koçlarımızdan online randevu alabilirsiniz.",
    "metaTitle": "Online Profesyonel Koç",
    "metaDescription": "Potansiyelinizi açığa çıkarması, kişisel gelişimizi arttırması ve sizin hedeflerinize ulaşma yolunda doğru seçimler yapmanıza ve emin adımlar atmanıza destek vermesi için Profesyonel Koçlarımızdan online randevu alabilirsiniz.",
    "imgUrl": "/category-images/profesyonel-koc.png",
    "parentId": 32,
    "slugLong": "/danismanliklar/isim-icin/kariyerim-icin/profesyonel-koc/",
    "slug": "/profesyonel-koc/",
    "level": 3,
    "keywords": "Profesyonel Koç, Online Profesyonel Koç"
  },
  {
    "id": 322,
    "title": "Hikaye Anlatıcılığı",
    "description": "Profesyonel ve sosyal hayatınızdaki iletişim becerilerinizi geliştirmek ve hitap ettiğiniz kitleyi etkiniz altına almak için Hikaye Anlatıcılarımızdan online görüşme için randevu alabilirsiniz.",
    "metaTitle": "Online Hikaye Anlatıcılığı",
    "metaDescription": "Profesyonel ve sosyal hayatınızdaki iletişim becerilerinizi geliştirmek ve hitap ettiğiniz kitleyi etkiniz altına almak için Hikaye Anlatıcılarımızdan online görüşme için randevu alabilirsiniz.",
    "imgUrl": "/category-images/hikaye-anlaticiligi.png",
    "parentId": 32,
    "slugLong": "/danismanliklar/isim-icin/kariyerim-icin/hikaye-anlaticiligi/",
    "slug": "/hikaye-anlaticiligi/",
    "level": 3,
    "keywords": "Hikaye Anlatıcılığı, Online Hikaye Anlatıcılığı"
  },
  {
    "id": 323,
    "title": "İnsan Kaynakları",
    "description": "İşe alım, iş arama süreçlerinizi kolaylaştırmak adına Uzmanlarımızdan online görüşme için randevu alabilirsiniz.",
    "metaTitle": "Online İnsan Kaynakları Danışmanlığı",
    "metaDescription": "İşe alım, iş arama süreçlerinizi kolaylaştırmak adına Uzmanlarımızdan online görüşme için randevu alabilirsiniz.",
    "imgUrl": "/category-images/insan-kaynaklari.png",
    "parentId": 32,
    "slugLong": "/danismanliklar/isim-icin/kariyerim-icin/insan-kaynaklari/",
    "slug": "/insan-kaynaklari/",
    "level": 3,
    "keywords": "İnsan Kaynakları Uzmanı, Online İnsan Kaynakları"
  },
  {
    "id": 757112,
    "title": "SGK/EYT Uzmanı\t",
    "description": "Sosyal güvenlik ve EYT konusunda sizlere yardımcı olarak uzmanlarımızdan online görüşme için randevu alabilirsiniz",
    "metaTitle": "Online SGK/EYT Uzmanlığı",
    "metaDescription": "Sosyal güvenlik ve EYT konusunda sizlere yardımcı olarak uzmanlarımızdan online görüşme için randevu alabilirsiniz",
    "imgUrl": "/category-images/sgk-eyt.png",
    "parentId": 32,
    "slugLong": "/danismanliklar/isim-icin/kariyerim-icin/sgk-eyt-uzmani/",
    "slug": "/sgk-eyt-uzmani/",
    "level": 3,
    "keywords": "SGK uzmanı, EYT uzmanı, Sosyal Güvenlik uzmanı"
  }
]

export const megaMenuContent: Record<'1' | '2' | '3', Array<Array<MenuContent>>> = {
  "1": [
    [
      {
        "href": "/",
        "text": "Ruh Sağlığım İçin"
      },
      {
        "href": "/danismanliklar/kendim-icin/ruhunuza-iyi-gelecek/psikoloji/",
        "text": "Psikoloji"
      },
      {
        "href": "/danismanliklar/kendim-icin/ruhunuza-iyi-gelecek/aile-danismanligi/",
        "text": "Aile Danışmanlığı"
      },
      {
        "href": "/danismanliklar/kendim-icin/ruhunuza-iyi-gelecek/cinsel-terapi/",
        "text": "Cinsel Terapi"
      },
      {
        "href": "/danismanliklar/kendim-icin/ruhunuza-iyi-gelecek/butunsel-terapi/",
        "text": "Bütünsel Terapi"
      },
      {
        "href": "/danismanliklar/kendim-icin/ruhunuza-iyi-gelecek/yasam-kocu/",
        "text": "Yaşam Koçu"
      }
    ],
    [
      {
        "href": "/",
        "text": "Bedenim İçin"
      },
      {
        "href": "/danismanliklar/kendim-icin/goruntum-icin/diyetisyen/",
        "text": "Diyetisyen"
      },
      {
        "href": "/danismanliklar/kendim-icin/goruntum-icin/spor/",
        "text": "Spor"
      },
      {
        "href": "/danismanliklar/kendim-icin/goruntum-icin/stil/",
        "text": "Stil"
      },
      {
        "href": "/danismanliklar/kendim-icin/goruntum-icin/fizyoterapi/",
        "text": "Fizyoterapi"
      }
    ],
    [
      {
        "href": "/",
        "text": "Enerji Terapisi"
      },
      {
        "href": "/danismanliklar/kendim-icin/enerji/astroloji/",
        "text": "Astroloji"
      },
      {
        "href": "/danismanliklar/kendim-icin/enerji/numeroloji/",
        "text": "Numeroloji"
      },
      {
        "href": "/danismanliklar/kendim-icin/enerji/nlp/",
        "text": "NLP"
      },
      {
        "href": "/danismanliklar/kendim-icin/enerji/reiki-enerji/",
        "text": "Reiki"
      },
      {
        "href": "/danismanliklar/kendim-icin/enerji/ailedizimi/",
        "text": "Aile Dizimi"
      },
      {
        "href": "/danismanliklar/kendim-icin/enerji/human-design/",
        "text": "Human Design"
      },
      {
        "href": "/danismanliklar/kendim-icin/enerji/kozmik-enerji/",
        "text": "Kozmik Enerji"
      },
      {
        "href": "/danismanliklar/kendim-icin/enerji/theta-healing/",
        "text": "Theta Healing"
      },
      {
        "href": "/danismanliklar/kendim-icin/enerji/mindfulness/",
        "text": "Mindfulness"
      },
      {
        "href": "/danismanliklar/kendim-icin/enerji/jaas/",
        "text": "JAAS"
      }
    ]
  ],
  "2": [
    [
      {
        "href": "/",
        "text": "Pedagoji"
      },
      {
        "href": "/danismanliklar/kids/pedagoji/cocuk-psikologu/",
        "text": "Çocuk Psikoloğu"
      }
    ],
    [
      {
        "href": "/",
        "text": "Gelişim"
      },
      {
        "href": "/danismanliklar/kids/gelisim-kids/cocuk-gelisim/",
        "text": "Çocuk Gelişimi"
      },
      {
        "href": "/danismanliklar/kids/gelisim-kids/ogrenci-kocu/",
        "text": "Öğrenci Koçu"
      },
      {
        "href": "/danismanliklar/kids/gelisim-kids/rehberlik/",
        "text": "Rehberlik"
      },
      {
        "href": "/danismanliklar/kids/gelisim-kids/diyetisyen-kids/",
        "text": "Beslenme Uzmanları"
      }
    ],
    [
      {
        "href": "/",
        "text": "Yeni Doğan"
      },
      {
        "href": "/danismanliklar/kids/yeni-dogan/uyku-danismanligi/",
        "text": "Uyku Danışmanlığı"
      },
      {
        "href": "/danismanliklar/kids/gelisim-kids/emzirme-danismanligi/",
        "text": "Emzirme Danışmanlığı"
      },
      {
        "href": "/danismanliklar/kids/yeni-dogan/ebeveyn-danismanligi/",
        "text": "Ebeveyn Danışmanlığı"
      }
    ]
  ],
  "3": [
    [
      {
        "href": "/",
        "text": "Girişim ve Kobi"
      },
      {
        "href": "/danismanliklar/isim-icin/girisim-ve-kobi/girisim/",
        "text": "Girişim"
      },
      {
        "href": "/danismanliklar/isim-icin/girisim-ve-kobi/sosyal-medya/",
        "text": "Sosyal Medya"
      },
      {
        "href": "/danismanliklar/isim-icin/girisim-ve-kobi/eticaret/",
        "text": "E-Ticaret"
      },
      {
        "href": "/danismanliklar/isim-icin/girisim-ve-kobi/muhasebe/",
        "text": "Muhasebe"
      },
      {
        "href": "/danismanliklar/isim-icin/girisim-ve-kobi/pazarlama/",
        "text": "Pazarlama"
      },
      {
        "href": "/danismanliklar/isim-icin/girisim-ve-kobi/is-gelistirme/",
        "text": "İş Geliştirme"
      },
      {
        "href": "/danismanliklar/isim-icin/girisim-ve-kobi/satis/",
        "text": "Satış"
      },
      {
        "href": "/danismanliklar/isim-icin/girisim-ve-kobi/tasarim/",
        "text": "Tasarım"
      }
    ],
    [
      {
        "href": "/",
        "text": "Kariyerim İçin"
      },
      {
        "href": "/danismanliklar/isim-icin/kariyerim-icin/profesyonel-koc/",
        "text": "Profesyonel Koç"
      },
      {
        "href": "/danismanliklar/isim-icin/kariyerim-icin/hikaye-anlaticiligi/",
        "text": "Hikaye Anlatıcılığı"
      },
      {
        "href": "/danismanliklar/isim-icin/kariyerim-icin/insan-kaynaklari/",
        "text": "İnsan Kaynakları"
      },
      {
        "href": "/danismanliklar/isim-icin/kariyerim-icin/sgk-eyt-uzmani/",
        "text": "SGK/EYT Uzmanı\t"
      }
    ]
  ]
}

export const slugMap: Record<string, Category> = {
  "online-psikolog": {
    "id": 111,
    "title": "Psikoloji",
    "description": "Yaşamın zorluklarıyla başa çıkmak ve ruhsal sağlığınızı güçlendirmek için profesyonel psikolojik destek. Mutluluğunuzun peşinden gidin.",
    "metaTitle": "Online Psikolog",
    "metaDescription": "Yaşamın zorluklarıyla başa çıkmak ve ruhsal sağlığınızı güçlendirmek için profesyonel psikolojik destek. Mutluluğunuzun peşinden gidin.",
    "imgUrl": "/category-images/psikoloji.png",
    "parentId": 11,
    "slugLong": "/danismanliklar/kendim-icin/ruhunuza-iyi-gelecek/psikoloji/",
    "slug": "/online-psikolog/",
    "level": 3,
    "keywords": "Psikoloji, online psikoloji, online psikolog, psikolog"
  },
  "aile-danismanligi": {
    "id": 112,
    "title": "Aile Danışmanlığı",
    "description": "Aile içi ilişkilerinizi güçlendirin ve çatışmaları çözün. Uzman aile danışmanlarımızla daha mutlu ve huzurlu bir aile yaşamı için adım atın.",
    "metaTitle": "Aile Danışmanlığı",
    "metaDescription": "Aile içi ilişkilerinizi güçlendirin ve çatışmaları çözün. Uzman aile danışmanlarımızla daha mutlu ve huzurlu bir aile yaşamı için adım atın.",
    "imgUrl": "/category-images/aile-danismanligi.png",
    "parentId": 11,
    "slugLong": "/danismanliklar/kendim-icin/ruhunuza-iyi-gelecek/aile-danismanligi/",
    "slug": "/aile-danismanligi/",
    "level": 3,
    "keywords": "Aile Danışmanlığı, Aile Danışmanı, Online Aile Danışmanı, Online Aile Danışmanlığı"
  },
  "cinsel-terapi": {
    "id": 113,
    "title": "Cinsel Terapi",
    "description": "Cinsel hayatınızı olumsuz etkileyen vajinismus, erken boşalma, sertleşme bozukluğu, kadın ve erkekte cinsel istek bozukluğu, kadında uyarılma bozukluğu, ağrılı cinsellik, kadın ve erkekte orgazm bozukluğu gibi problemlerinizi aşmanızda size destek olması için Cinsel Terapistlerimizden online randevu alabilirsiniz.",
    "metaTitle": "Online Cinsel Terapi",
    "metaDescription": "Cinsel hayatınızı olumsuz etkileyen vajinismus, erken boşalma, sertleşme bozukluğu, kadın ve erkekte cinsel istek bozukluğu, kadında uyarılma bozukluğu, ağrılı cinsellik, kadın ve erkekte orgazm bozukluğu gibi problemlerinizi aşmanızda size destek olması için Cinsel Terapistlerimizden online randevu alabilirsiniz.",
    "imgUrl": "/category-images/cinsel-terapi.png",
    "parentId": 11,
    "slugLong": "/danismanliklar/kendim-icin/ruhunuza-iyi-gelecek/cinsel-terapi/",
    "slug": "/cinsel-terapi/",
    "level": 3,
    "keywords": "Cinsel terapi, online cinsel terapi"
  },
  "butunsel-terapi": {
    "id": 114,
    "title": "Bütünsel Terapi",
    "description": "Bütünsel terapi yöntemleriyle fiziksel, zihinsel ve ruhsal sağlığınızı bütünleştirin. Yaşam kalitenizi artırın.Detayları öğrenmek ve deneyimlemek için tıklayın.",
    "metaTitle": "Online Bütünsel Terapi",
    "metaDescription": "Bütünsel terapi yöntemleriyle fiziksel, zihinsel ve ruhsal sağlığınızı bütünleştirin. Yaşam kalitenizi artırın.Detayları öğrenmek ve deneyimlemek için tıklayın.",
    "imgUrl": "/category-images/butunsel-terapi.png",
    "parentId": 11,
    "slugLong": "/danismanliklar/kendim-icin/ruhunuza-iyi-gelecek/butunsel-terapi/",
    "slug": "/butunsel-terapi/",
    "level": 3,
    "keywords": "Bütünsel Terapi, Online Bütünsel Terapi, Bütünsel Terapi Uzmanı, Online Bütünsel Terapi Uzmanı"
  },
  "yasam-kocu": {
    "id": 115,
    "title": "Yaşam Koçu",
    "description": "Hedeflerinize ulaşmanız için size rehberlik edecek profesyonel yaşam koçları. Motivasyon, hedef belirleme ve daha fazlası için tıklayın.",
    "metaTitle": "Online Yaşam Koçu",
    "metaDescription": "Hedeflerinize ulaşmanız için size rehberlik edecek profesyonel yaşam koçları. Motivasyon, hedef belirleme ve daha fazlası için tıklayın.",
    "imgUrl": "/category-images/yasam-kocu.png",
    "parentId": 11,
    "slugLong": "/danismanliklar/kendim-icin/ruhunuza-iyi-gelecek/yasam-kocu/",
    "slug": "/yasam-kocu/",
    "level": 3,
    "keywords": "Yaşam Koçu, Online Yaşam Koçu"
  },
  "diyetisyen": {
    "id": 121,
    "title": "Diyetisyen",
    "description": "Sağlığınızla ve kilonuzla ilgili ulaşmak istediğiniz hedeflerde size yol göstermesi ve sağlıklı bir yaşam tarzı benimsemeniz için size destek olması için Uzman Diyetisyenlerimizden online randevu alabilirsiniz.",
    "metaTitle": "Online Diyetisyen",
    "metaDescription": "Sağlığınızla ve kilonuzla ilgili ulaşmak istediğiniz hedeflerde size yol göstermesi ve sağlıklı bir yaşam tarzı benimsemeniz için size destek olması için Uzman Diyetisyenlerimizden online randevu alabilirsiniz.",
    "imgUrl": "/category-images/diyetisyen.png",
    "parentId": 12,
    "slugLong": "/danismanliklar/kendim-icin/goruntum-icin/diyetisyen/",
    "slug": "/diyetisyen/",
    "level": 3,
    "keywords": "Diyetisyen, Online Diyetisyen"
  },
  "spor": {
    "id": 122,
    "title": "Spor",
    "description": "Spor alışkanlıklarınızı değiştirmek, düzenlemek ve sürdürülebilir bir programı takip etmenize ve motivasyonunuzu ve disiplininizi kuvvetlendirmenize destek olması için Spor Uzmanlarımızdan online randevu alabilirsiniz.",
    "metaTitle": "Online Spor Antrenörü",
    "metaDescription": "Spor alışkanlıklarınızı değiştirmek, düzenlemek ve sürdürülebilir bir programı takip etmenize ve motivasyonunuzu ve disiplininizi kuvvetlendirmenize destek olması için Spor Uzmanlarımızdan online randevu alabilirsiniz.",
    "imgUrl": "/category-images/spor.png",
    "parentId": 12,
    "slugLong": "/danismanliklar/kendim-icin/goruntum-icin/spor/",
    "slug": "/spor/",
    "level": 3,
    "keywords": "Online Spor"
  },
  "stil": {
    "id": 123,
    "title": "Stil",
    "description": "Stilinizi geliştirmek ve nasıl giyinmenin size daha fazla yakışacağını öğrenmek için uzman stil danışmanlarımızdan randevu alabilir ve yani bir imaja sahip olabilirsiniz.",
    "metaTitle": "Online Stil Danışmanı",
    "metaDescription": "Stilinizi geliştirmek ve nasıl giyinmenin size daha fazla yakışacağını öğrenmek için uzman stil danışmanlarımızdan randevu alabilir ve yani bir imaja sahip olabilirsiniz.",
    "imgUrl": "/category-images/stil.png",
    "parentId": 12,
    "slugLong": "/danismanliklar/kendim-icin/goruntum-icin/stil/",
    "slug": "/stil/",
    "level": 3,
    "keywords": "Stil Danışmanı, Stil Danışmanlığı, Online Stil Danışmanı, Online Stil Danışmanlığı"
  },
  "fizyoterapi": {
    "id": 602020,
    "title": "Fizyoterapi",
    "description": "Vücudunuzdaki ağrıların ve hareket kısıtlılıklarının farkındaysanız, kas ve eklem sağlığınızı geri kazanmanıza yardımcı olacak fizyoterapi hizmetlerimizden faydalanabilirsiniz. Uzman fizyoterapistlerimizden online randevu alarak, daha sağlıklı ve ağrısız bir yaşama adım atın.",
    "metaTitle": "Online Fizyoterapi",
    "metaDescription": "Vücudunuzdaki ağrıların ve hareket kısıtlılıklarının farkındaysanız, kas ve eklem sağlığınızı geri kazanmanıza yardımcı olacak fizyoterapi hizmetlerimizden faydalanabilirsiniz. Uzman fizyoterapistlerimizden online randevu alarak, daha sağlıklı ve ağrısız bir yaşama adım atın.",
    "imgUrl": "/category-images/fizyoterapi.png",
    "parentId": 12,
    "slugLong": "/danismanliklar/kendim-icin/goruntum-icin/fizyoterapi/",
    "slug": "/fizyoterapi/",
    "level": 3,
    "keywords": "fizyoterapi, online fizyoterapi, fizyoterapist, online fizyoterapist"
  },
  "astroloji": {
    "id": 131,
    "title": "Astroloji",
    "description": "Gök cisimlerinin konumları ve döngüleri ile dünyadaki fiziksel süreçler ve yaşam arasındaki eşzamanlılığın ışığında, Doğum haritası belirleme, Yıllık astroloji, Doğum saati belirleme ile hayatınızı yönlendirmenizde ve düzenlemenizde destek almak istiyorsanız Astrologlarımızdan online randevu alabilirsiniz. ‌",
    "metaTitle": "Online Astrolog",
    "metaDescription": "Gök cisimlerinin konumları ve döngüleri ile dünyadaki fiziksel süreçler ve yaşam arasındaki eşzamanlılığın ışığında, Doğum haritası belirleme, Yıllık astroloji, Doğum saati belirleme ile hayatınızı yönlendirmenizde ve düzenlemenizde destek almak istiyorsanız Astrologlarımızdan online randevu alabilirsiniz. ‌",
    "imgUrl": "/category-images/astroloji.png",
    "parentId": 13,
    "slugLong": "/danismanliklar/kendim-icin/enerji/astroloji/",
    "slug": "/astroloji/",
    "level": 3,
    "keywords": "Astroloji, Astrolog, Online Astroloji, Online Astrolog, Doğum Haritası Yorumlama"
  },
  "numeroloji": {
    "id": 137,
    "title": "Numeroloji",
    "description": "Sayıların hayatınızdaki öneminin ve etkisinin farkındaysanız, kişiliğiniz, yetenekleriniz ve zayıflıklarınız ve gelecekte yaşamanız olası durumlarla ilgili sayıların yorumlarını anlamanızda destek olması için Numerologlarımızdan online randevu alabilirsiniz. ‌ ‌",
    "metaTitle": "Online Numeroloji",
    "metaDescription": "Sayıların hayatınızdaki öneminin ve etkisinin farkındaysanız, kişiliğiniz, yetenekleriniz ve zayıflıklarınız ve gelecekte yaşamanız olası durumlarla ilgili sayıların yorumlarını anlamanızda destek olması için Numerologlarımızdan online randevu alabilirsiniz. ‌ ‌",
    "imgUrl": "/category-images/numeroloji.png",
    "parentId": 13,
    "slugLong": "/danismanliklar/kendim-icin/enerji/numeroloji/",
    "slug": "/numeroloji/",
    "level": 3,
    "keywords": "Numeroloji, Online Numeroloji"
  },
  "nlp": {
    "id": 132,
    "title": "NLP",
    "description": "NLP tekniği uzmanlarımızın yardımı ile ihtiyacını duyduğunuz motivasyonu yaratabilir, düşüncelerde sadeleşmeyi alışkanlık haline getirebilir, geçmişle olan negatif bağları koparıp geleceğinizi tasarlamaya başlayabilirsiniz.",
    "metaTitle": "Online NLP Uzmanı",
    "metaDescription": "NLP tekniği uzmanlarımızın yardımı ile ihtiyacını duyduğunuz motivasyonu yaratabilir, düşüncelerde sadeleşmeyi alışkanlık haline getirebilir, geçmişle olan negatif bağları koparıp geleceğinizi tasarlamaya başlayabilirsiniz.",
    "imgUrl": "/category-images/nlp.png",
    "parentId": 13,
    "slugLong": "/danismanliklar/kendim-icin/enerji/nlp/",
    "slug": "/nlp/",
    "level": 3,
    "keywords": "NLP Uzmanı, NLP Danışmanlığı, Online NLP Uzmanı, Online NLP Danışmanlığı"
  },
  "reiki-enerji": {
    "id": 133,
    "title": "Reiki",
    "description": "Evrensel Yaşam enerjisinin aktarma alanında uzmanlaşmış Reiki uzmanlarımızdan randevu alarak, Öz benliğinizde ve bedeninizde gerçekleşmesini istediğiniz iyileşmeyi destekleyebilir, stresinizi azaltabilir ve derin bir rahatlama sağlayabilirsiniz.",
    "metaTitle": "Online Reiki Uzmanı",
    "metaDescription": "Evrensel Yaşam enerjisinin aktarma alanında uzmanlaşmış Reiki uzmanlarımızdan randevu alarak, Öz benliğinizde ve bedeninizde gerçekleşmesini istediğiniz iyileşmeyi destekleyebilir, stresinizi azaltabilir ve derin bir rahatlama sağlayabilirsiniz.",
    "imgUrl": "/category-images/reiki.png",
    "parentId": 13,
    "slugLong": "/danismanliklar/kendim-icin/enerji/reiki-enerji/",
    "slug": "/reiki-enerji/",
    "level": 3,
    "keywords": "Reiki, Online Reiki Uzmanı, Reiki Uzmanı, Online Reiki"
  },
  "ailedizimi": {
    "id": 134,
    "title": "Aile Dizimi",
    "description": "Hayatınızdaki tekrar eden negatif olayları ve üstesinden gelemediğiniz psikolojik sorunlarınızı ve travmalarınızı çözmek için Aile dizimini deneyebilir ve nesillerdir tekrar eden döngüleri kırarak daha özgür bir hayat yaşayabilirsiniz.",
    "metaTitle": "Online Aile Dizimi",
    "metaDescription": "Hayatınızdaki tekrar eden negatif olayları ve üstesinden gelemediğiniz psikolojik sorunlarınızı ve travmalarınızı çözmek için Aile dizimini deneyebilir ve nesillerdir tekrar eden döngüleri kırarak daha özgür bir hayat yaşayabilirsiniz.",
    "imgUrl": "/category-images/aile-dizilimi.png",
    "parentId": 13,
    "slugLong": "/danismanliklar/kendim-icin/enerji/ailedizimi/",
    "slug": "/ailedizimi/",
    "level": 3,
    "keywords": "Aile Dizimi, Online Aile Dizimi"
  },
  "human-design": {
    "id": 135,
    "title": "Human Design",
    "description": "Doğu ve Batı Astrolojisi, I Chinq, Kabala, Çakra Sistemlerinin tamamını içeren Human design sistemi ile sadece size özel olan doğum tasarımınızı keşfederek hem kendinizi daha bütünsel anlayabilir hem de sevdiklerinizle olan ilişkinizi derinleştirebilirsiniz.",
    "metaTitle": "Online Human Design",
    "metaDescription": "Doğu ve Batı Astrolojisi, I Chinq, Kabala, Çakra Sistemlerinin tamamını içeren Human design sistemi ile sadece size özel olan doğum tasarımınızı keşfederek hem kendinizi daha bütünsel anlayabilir hem de sevdiklerinizle olan ilişkinizi derinleştirebilirsiniz.",
    "imgUrl": "/category-images/human-design.png",
    "parentId": 13,
    "slugLong": "/danismanliklar/kendim-icin/enerji/human-design/",
    "slug": "/human-design/",
    "level": 3,
    "keywords": "Human Design, Online Human Design"
  },
  "kozmik-enerji": {
    "id": 333,
    "title": "Kozmik Enerji",
    "description": "Kozmik Enerji uzmanlarımızdan randevu alarak, uzmanlarımızın kullandıkları kanallar vasıtasıyla ihtiyacını duyduğunuz şifayı kendinize evinizin konforunda ulaştırabilirsiniz.",
    "metaTitle": "Online Kozmik Enerji",
    "metaDescription": "Kozmik Enerji uzmanlarımızdan randevu alarak, uzmanlarımızın kullandıkları kanallar vasıtasıyla ihtiyacını duyduğunuz şifayı kendinize evinizin konforunda ulaştırabilirsiniz.",
    "imgUrl": "/category-images/kozmik-enerji.png",
    "parentId": 13,
    "slugLong": "/danismanliklar/kendim-icin/enerji/kozmik-enerji/",
    "slug": "/kozmik-enerji/",
    "level": 3,
    "keywords": "Kozmik Enerji, Online Kozmik Enerji, Kozmik Enerji Uzmanı"
  },
  "theta-healing": {
    "id": 136,
    "title": "Theta Healing",
    "description": "Her şeyi yaratan, evrenin tek bileşeninin enerji seviyesinden şifa almak ve hayatınızı bu enerji ile yükseltmek için destek almak istiyorsanız Theta Healing uzmanlarımızdan online randevu alabilirsiniz.",
    "metaTitle": "Online Theta Healing",
    "metaDescription": "Her şeyi yaratan, evrenin tek bileşeninin enerji seviyesinden şifa almak ve hayatınızı bu enerji ile yükseltmek için destek almak istiyorsanız Theta Healing uzmanlarımızdan online randevu alabilirsiniz.",
    "imgUrl": "/category-images/theta-healing.png",
    "parentId": 13,
    "slugLong": "/danismanliklar/kendim-icin/enerji/theta-healing/",
    "slug": "/theta-healing/",
    "level": 3,
    "keywords": "Theta Healing, Online Theta Healing, Theta Healing Uzmanı, Theta Healing Uygulayıcısı"
  },
  "mindfulness": {
    "id": 639181,
    "title": "Mindfulness",
    "description": "Mindfulness uzmanları ile stres yönetimi, odaklanma ve iç huzur için etkili teknikler öğrenin. Bilinçli farkındalık pratiği ile zihinsel ve duygusal dengeyi sağlayarak, yaşam kalitenizi artırın. Kişiye özel mindfulness seanslarımız hemen online randevu alabilirsiniz.",
    "metaTitle": "Online Mindfulness",
    "metaDescription": "Mindfulness uzmanları ile stres yönetimi, odaklanma ve iç huzur için etkili teknikler öğrenin. Bilinçli farkındalık pratiği ile zihinsel ve duygusal dengeyi sağlayarak, yaşam kalitenizi artırın. Kişiye özel mindfulness seanslarımız hemen online randevu alabilirsiniz.",
    "imgUrl": "/category-images/mindfulness.png",
    "parentId": 13,
    "slugLong": "/danismanliklar/kendim-icin/enerji/mindfulness/",
    "slug": "/mindfulness/",
    "level": 3,
    "keywords": "mindfulness, online mindfulness, Bilinçli Farkındalık"
  },
  "jaas": {
    "id": 495139,
    "title": "JAAS",
    "description": "Hayatınızdaki enerji blokajlarını ve ruhsal engelleri fark ediyorsanız, JAAS yöntemi ile bu blokajları çözümleyerek ruhsal dengeyi ve iç huzuru bulmanıza yardımcı olabiliriz. Jean Adrienne Arınma Sistemi uzmanlarımızdan online randevu alarak, kendinizdeki bu değişimi başlatabilirsiniz.",
    "metaTitle": "Online JAAS",
    "metaDescription": "Hayatınızdaki enerji blokajlarını ve ruhsal engelleri fark ediyorsanız, JAAS yöntemi ile bu blokajları çözümleyerek ruhsal dengeyi ve iç huzuru bulmanıza yardımcı olabiliriz. Jean Adrienne Arınma Sistemi uzmanlarımızdan online randevu alarak, kendinizdeki bu değişimi başlatabilirsiniz.",
    "imgUrl": "/category-images/jaas.png",
    "parentId": 13,
    "slugLong": "/danismanliklar/kendim-icin/enerji/jaas/",
    "slug": "/jaas/",
    "level": 3,
    "keywords": "jaas, online jaas, Jean Adrienne Arınma Sistemi (JAAS)"
  },
  "cocuk-psikologu": {
    "id": 211,
    "title": "Çocuk Psikoloğu",
    "description": "Çocuğunuzun duygusal ve sosyal gelişimini destekleyin. Uzman çocuk psikoloğumuzla güvenli ve destekleyici bir ortam yaratabilmek için bugün bizden destek alın.",
    "metaTitle": "Online Çocuk Psikoloğu",
    "metaDescription": "Çocuğunuzun duygusal ve sosyal gelişimini destekleyin. Uzman çocuk psikoloğumuzla güvenli ve destekleyici bir ortam yaratabilmek için bugün bizden destek alın.",
    "imgUrl": "/category-images/cocuk-psikologu.png",
    "parentId": 21,
    "slugLong": "/danismanliklar/kids/pedagoji/cocuk-psikologu/",
    "slug": "/cocuk-psikologu/",
    "level": 3,
    "keywords": "Çocuk Psikoloğu, Online Çocuk Psikoloğu, Pedagog, Online Pedagog"
  },
  "cocuk-gelisim": {
    "id": 221,
    "title": "Çocuk Gelişimi",
    "description": "Çocuğunuzun her aşamasında yanınızdayız. Gelişimsel dönemlere uygun stratejiler ve aktivitelerle çocuğunuzun potansiyelini keşfedin.",
    "metaTitle": "Online Çocuk Gelişim Uzmanları",
    "metaDescription": "Çocuğunuzun her aşamasında yanınızdayız. Gelişimsel dönemlere uygun stratejiler ve aktivitelerle çocuğunuzun potansiyelini keşfedin.",
    "imgUrl": "/category-images/cocuk-gelisimi.png",
    "parentId": 22,
    "slugLong": "/danismanliklar/kids/gelisim-kids/cocuk-gelisim/",
    "slug": "/cocuk-gelisim/",
    "level": 3,
    "keywords": "Çocuk Gelişim, Çocuk Gelişim Uzmanı, Online Çocuk Gelişim, Online Çocuk Gelişim Uzmanı"
  },
  "ogrenci-kocu": {
    "id": 222,
    "title": "Öğrenci Koçu",
    "description": "Eğitim yolculuğunuzda size destek olan öğrenci koçları. Motivasyon, zaman yönetimi ve sınav hazırlığı için profesyonel yardım almak için tıklayın. ",
    "metaTitle": "Online Öğrenci Koçu",
    "metaDescription": "Eğitim yolculuğunuzda size destek olan öğrenci koçları. Motivasyon, zaman yönetimi ve sınav hazırlığı için profesyonel yardım almak için tıklayın. ",
    "imgUrl": "/category-images/ogrenci-kocu.png",
    "parentId": 22,
    "slugLong": "/danismanliklar/kids/gelisim-kids/ogrenci-kocu/",
    "slug": "/ogrenci-kocu/",
    "level": 3,
    "keywords": "Öğrenci Koçu, Online Öğrenci Koçu"
  },
  "rehberlik": {
    "id": 223,
    "title": "Rehberlik",
    "description": "Hayatınızdaki önemli kararlar için profesyonel rehberlik ve destek. Kariyer, eğitim ve kişisel gelişim yolculuğunuzda yanınızdayız.",
    "metaTitle": "Online Rehberlik Uzmanı",
    "metaDescription": "Hayatınızdaki önemli kararlar için profesyonel rehberlik ve destek. Kariyer, eğitim ve kişisel gelişim yolculuğunuzda yanınızdayız.",
    "imgUrl": "/category-images/rehberlik.png",
    "parentId": 22,
    "slugLong": "/danismanliklar/kids/gelisim-kids/rehberlik/",
    "slug": "/rehberlik/",
    "level": 3,
    "keywords": "Rehberlik Uzmanı, Online Rehberlik Uzmanı"
  },
  "diyetisyen-kids": {
    "id": 224,
    "title": "Beslenme Uzmanları",
    "description": "Sağlıklı beslenme alışkanlıkları edinin ve yaşam kalitenizi artırın. Uzman diyetisyenlerimizle kişiye özel beslenme planları oluşturmak için tıklayın.",
    "metaTitle": "Online Beslenme Uzmanları",
    "metaDescription": "Sağlıklı beslenme alışkanlıkları edinin ve yaşam kalitenizi artırın. Uzman diyetisyenlerimizle kişiye özel beslenme planları oluşturmak için tıklayın.",
    "imgUrl": "/category-images/beslenme-uzmanlari.png",
    "parentId": 22,
    "slugLong": "/danismanliklar/kids/gelisim-kids/diyetisyen-kids/",
    "slug": "/diyetisyen-kids/",
    "level": 3,
    "keywords": "Çocuk Beslenme Uzmanları, Çocuk Diyetisyen, Çocuk Beslenme Uzmanı, Online Çocuk Beslenme Uzmanları, Online Çocuk Diyetisyen, Online Çocuk Beslenme Uzmanı"
  },
  "uyku-danismanligi": {
    "id": 231,
    "title": "Uyku Danışmanlığı",
    "description": "\nBebeklerde uyku konusunda yaşadığınız zorluklara uzun vadeli ve dengeli çözümler arıyorsanız Uyku Danışmanlarımızdan online randevu alabilirsiniz.",
    "metaTitle": "Online Uyku Danışmanlığı",
    "metaDescription": "\nBebeklerde uyku konusunda yaşadığınız zorluklara uzun vadeli ve dengeli çözümler arıyorsanız Uyku Danışmanlarımızdan online randevu alabilirsiniz.",
    "imgUrl": "/category-images/uyku-danismanligi.png",
    "parentId": 23,
    "slugLong": "/danismanliklar/kids/yeni-dogan/uyku-danismanligi/",
    "slug": "/uyku-danismanligi/",
    "level": 3,
    "keywords": "Uyku Danışmanlığı, Online Uyku Danışmanlığı, Bebek Uyku Danışmanı, Online Bebek Uyku Danışmanı"
  },
  "emzirme-danismanligi": {
    "id": 232,
    "title": "Emzirme Danışmanlığı",
    "description": "Emzirme döneminde desteğe ihtiyaç duyuyorsanız, bu konuda özel eğitim almış danışmanlarımızdan online görüşme için randevu alabilirsiniz.",
    "metaTitle": "Online Emzirme Danışmanlığı",
    "metaDescription": "Emzirme döneminde desteğe ihtiyaç duyuyorsanız, bu konuda özel eğitim almış danışmanlarımızdan online görüşme için randevu alabilirsiniz.",
    "imgUrl": "/category-images/emzirme-danismanligi.png",
    "parentId": 23,
    "slugLong": "/danismanliklar/kids/gelisim-kids/emzirme-danismanligi/",
    "slug": "/emzirme-danismanligi/",
    "level": 3,
    "keywords": "Emzirme Danışmanlığı, Online Emzirme Danışmanlığı"
  },
  "ebeveyn-danismanligi": {
    "id": 233,
    "title": "Ebeveyn Danışmanlığı",
    "description": "Ebeveyn olarak çocuğunuzun ruhsal, sosyal ve duygusal sağlığını desteklemek ve gelişimlerini desteklemek ihtiyacı içindeyseniz Ebeveyn Danışmanlarımızdan online görüşme için randevu alabilirsiniz.",
    "metaTitle": "Online Ebeveyn Danışmanlığı",
    "metaDescription": "Ebeveyn olarak çocuğunuzun ruhsal, sosyal ve duygusal sağlığını desteklemek ve gelişimlerini desteklemek ihtiyacı içindeyseniz Ebeveyn Danışmanlarımızdan online görüşme için randevu alabilirsiniz.",
    "imgUrl": "/category-images/ebeveyn-danismanligi.png",
    "parentId": 23,
    "slugLong": "/danismanliklar/kids/yeni-dogan/ebeveyn-danismanligi/",
    "slug": "/ebeveyn-danismanligi/",
    "level": 3,
    "keywords": "Ebeveyn Danışmanı, Ebeveyn Danışmanlığı, Online Ebeveyn Danışmanı, Online Ebeveyn Danışmanlığı"
  },
  "girisim": {
    "id": 311,
    "title": "Girişim",
    "description": "Girişim bilgisini, iş zekası ve tecrübeleriyle birleştirerek, kârlı bir ürün / marka oluşturmanız yolunda destek vermesi için Girişim Uzmanlarımızdan online randevu alabilirsiniz.",
    "metaTitle": "Online Girişim Danışmanı",
    "metaDescription": "Girişim bilgisini, iş zekası ve tecrübeleriyle birleştirerek, kârlı bir ürün / marka oluşturmanız yolunda destek vermesi için Girişim Uzmanlarımızdan online randevu alabilirsiniz.",
    "imgUrl": "/category-images/girisim.png",
    "parentId": 31,
    "slugLong": "/danismanliklar/isim-icin/girisim-ve-kobi/girisim/",
    "slug": "/girisim/",
    "level": 3,
    "keywords": "Girişim Danışmanı, Online Girişim Danışmanı"
  },
  "sosyal-medya": {
    "id": 312,
    "title": "Sosyal Medya",
    "description": "Markanızı yönetirken değişen ve genişleyen dünya trendlerini takip etmeniz ve marka bilinirliğinizi arttırmak, güncel pazarlama faaliyetlerini geliştirmeniz yolunda destek vermesi için Sosyal Medya Uzmanlarımızdan online randevu alabilirsiniz.",
    "metaTitle": "Online Sosyal Medya Uzmanı",
    "metaDescription": "Markanızı yönetirken değişen ve genişleyen dünya trendlerini takip etmeniz ve marka bilinirliğinizi arttırmak, güncel pazarlama faaliyetlerini geliştirmeniz yolunda destek vermesi için Sosyal Medya Uzmanlarımızdan online randevu alabilirsiniz.",
    "imgUrl": "/category-images/sosyal-medya.png",
    "parentId": 31,
    "slugLong": "/danismanliklar/isim-icin/girisim-ve-kobi/sosyal-medya/",
    "slug": "/sosyal-medya/",
    "level": 3,
    "keywords": "Sosyal Medya Uzmanı"
  },
  "eticaret": {
    "id": 313,
    "title": "E-Ticaret",
    "description": "E-ticaret web sitenizle ön plana çıkmak mı istiyorsunuz? Trendleri öğrenmek ve işinizi yukarı çıkarmak için ihtiyaç duyduğunuz, aklınıza takılan her soruya cevap bulmak ve sürecinizi daha hızlı ve daha etkin hale getirmek için bu konuda uzman danışmanlarımızdan online görüşme için randevu alabilirsiniz.",
    "metaTitle": "Online E-Ticaret Danışmanı",
    "metaDescription": "E-ticaret web sitenizle ön plana çıkmak mı istiyorsunuz? Trendleri öğrenmek ve işinizi yukarı çıkarmak için ihtiyaç duyduğunuz, aklınıza takılan her soruya cevap bulmak ve sürecinizi daha hızlı ve daha etkin hale getirmek için bu konuda uzman danışmanlarımızdan online görüşme için randevu alabilirsiniz.",
    "imgUrl": "/category-images/e-ticaret.png",
    "parentId": 31,
    "slugLong": "/danismanliklar/isim-icin/girisim-ve-kobi/eticaret/",
    "slug": "/eticaret/",
    "level": 3,
    "keywords": "E-Ticaret Danışmanı, Online E-Ticaret Danışmanı"
  },
  "muhasebe": {
    "id": 314,
    "title": "Muhasebe",
    "description": "Kendi muhasebeciniz yok mu veya başka bir görüş mü istiyorsunuz? Bireysel veya Kurumsal muhasebe konularında destek almak için Muhasebe Uzmanlarımızdan online görüşme için randevu alabilirsiniz.",
    "metaTitle": "Online Muhasebe Danışmanı",
    "metaDescription": "Kendi muhasebeciniz yok mu veya başka bir görüş mü istiyorsunuz? Bireysel veya Kurumsal muhasebe konularında destek almak için Muhasebe Uzmanlarımızdan online görüşme için randevu alabilirsiniz.",
    "imgUrl": "/category-images/muhasebe.png",
    "parentId": 31,
    "slugLong": "/danismanliklar/isim-icin/girisim-ve-kobi/muhasebe/",
    "slug": "/muhasebe/",
    "level": 3,
    "keywords": "Muhasebe Danışmanı, Online Muhasebe Danışmanı"
  },
  "pazarlama": {
    "id": 315,
    "title": "Pazarlama",
    "description": "Mevcut pazarınızla ilgili durumu değerlendirmek, müşteri ve ürünü buluştururken doğru ve efektif adımların atılması yolunda destek vermesi için Pazarlama Uzmanlarımızdan online randevu alabilirsiniz.",
    "metaTitle": "Online Pazarlama Danışmanı",
    "metaDescription": "Mevcut pazarınızla ilgili durumu değerlendirmek, müşteri ve ürünü buluştururken doğru ve efektif adımların atılması yolunda destek vermesi için Pazarlama Uzmanlarımızdan online randevu alabilirsiniz.",
    "imgUrl": "/category-images/pazarlama.png",
    "parentId": 31,
    "slugLong": "/danismanliklar/isim-icin/girisim-ve-kobi/pazarlama/",
    "slug": "/pazarlama/",
    "level": 3,
    "keywords": "Pazarlama Danışmanı, Online Pazarlama Danışmanı"
  },
  "is-gelistirme": {
    "id": 316,
    "title": "İş Geliştirme",
    "description": "İşinizi geliştirirken yeni müşteriler ve pazarlar bulunması, müşteri ihtiyaçlarını analiz ederek ürünün geliştirilmesi konularında destek vermesi için İş Geliştirme Uzmanlarımızdan online randevu alabilirsiniz.",
    "metaTitle": "Online İş Geliştirme",
    "metaDescription": "İşinizi geliştirirken yeni müşteriler ve pazarlar bulunması, müşteri ihtiyaçlarını analiz ederek ürünün geliştirilmesi konularında destek vermesi için İş Geliştirme Uzmanlarımızdan online randevu alabilirsiniz.",
    "imgUrl": "/category-images/is-gelistirme.png",
    "parentId": 31,
    "slugLong": "/danismanliklar/isim-icin/girisim-ve-kobi/is-gelistirme/",
    "slug": "/is-gelistirme/",
    "level": 3,
    "keywords": "İş Geliştirme Uzmanı"
  },
  "satis": {
    "id": 317,
    "title": "Satış",
    "description": "Ürününüz var ve satış konusunda destek arıyorsanız, Satış Danışmanlarımızdan online görüşme için randevu alabilir ve büyümenizi hızlandırabilirsiniz.",
    "metaTitle": "Online Satış Danışmanı",
    "metaDescription": "Ürününüz var ve satış konusunda destek arıyorsanız, Satış Danışmanlarımızdan online görüşme için randevu alabilir ve büyümenizi hızlandırabilirsiniz.",
    "imgUrl": "/category-images/satis.png",
    "parentId": 31,
    "slugLong": "/danismanliklar/isim-icin/girisim-ve-kobi/satis/",
    "slug": "/satis/",
    "level": 3,
    "keywords": "Online Satış Uzmanı, Satış Danışmanı"
  },
  "tasarim": {
    "id": 318,
    "title": "Tasarım",
    "description": "Tasarıma ürün olan her türlü konu için süreç danışmanlığı almak ve ürünün doğru mesajı vermesinde ve doğru konumlandırılması destek almak için Tasarım Danışmanlarımızdan online randevu alabilirsiniz.",
    "metaTitle": "Online Tasarım Danışmanı",
    "metaDescription": "Tasarıma ürün olan her türlü konu için süreç danışmanlığı almak ve ürünün doğru mesajı vermesinde ve doğru konumlandırılması destek almak için Tasarım Danışmanlarımızdan online randevu alabilirsiniz.",
    "imgUrl": "/category-images/tasarim.png",
    "parentId": 31,
    "slugLong": "/danismanliklar/isim-icin/girisim-ve-kobi/tasarim/",
    "slug": "/tasarim/",
    "level": 3,
    "keywords": "Tasarım Uzmanı"
  },
  "profesyonel-koc": {
    "id": 321,
    "title": "Profesyonel Koç",
    "description": "Potansiyelinizi açığa çıkarması, kişisel gelişimizi arttırması ve sizin hedeflerinize ulaşma yolunda doğru seçimler yapmanıza ve emin adımlar atmanıza destek vermesi için Profesyonel Koçlarımızdan online randevu alabilirsiniz.",
    "metaTitle": "Online Profesyonel Koç",
    "metaDescription": "Potansiyelinizi açığa çıkarması, kişisel gelişimizi arttırması ve sizin hedeflerinize ulaşma yolunda doğru seçimler yapmanıza ve emin adımlar atmanıza destek vermesi için Profesyonel Koçlarımızdan online randevu alabilirsiniz.",
    "imgUrl": "/category-images/profesyonel-koc.png",
    "parentId": 32,
    "slugLong": "/danismanliklar/isim-icin/kariyerim-icin/profesyonel-koc/",
    "slug": "/profesyonel-koc/",
    "level": 3,
    "keywords": "Profesyonel Koç, Online Profesyonel Koç"
  },
  "hikaye-anlaticiligi": {
    "id": 322,
    "title": "Hikaye Anlatıcılığı",
    "description": "Profesyonel ve sosyal hayatınızdaki iletişim becerilerinizi geliştirmek ve hitap ettiğiniz kitleyi etkiniz altına almak için Hikaye Anlatıcılarımızdan online görüşme için randevu alabilirsiniz.",
    "metaTitle": "Online Hikaye Anlatıcılığı",
    "metaDescription": "Profesyonel ve sosyal hayatınızdaki iletişim becerilerinizi geliştirmek ve hitap ettiğiniz kitleyi etkiniz altına almak için Hikaye Anlatıcılarımızdan online görüşme için randevu alabilirsiniz.",
    "imgUrl": "/category-images/hikaye-anlaticiligi.png",
    "parentId": 32,
    "slugLong": "/danismanliklar/isim-icin/kariyerim-icin/hikaye-anlaticiligi/",
    "slug": "/hikaye-anlaticiligi/",
    "level": 3,
    "keywords": "Hikaye Anlatıcılığı, Online Hikaye Anlatıcılığı"
  },
  "insan-kaynaklari": {
    "id": 323,
    "title": "İnsan Kaynakları",
    "description": "İşe alım, iş arama süreçlerinizi kolaylaştırmak adına Uzmanlarımızdan online görüşme için randevu alabilirsiniz.",
    "metaTitle": "Online İnsan Kaynakları Danışmanlığı",
    "metaDescription": "İşe alım, iş arama süreçlerinizi kolaylaştırmak adına Uzmanlarımızdan online görüşme için randevu alabilirsiniz.",
    "imgUrl": "/category-images/insan-kaynaklari.png",
    "parentId": 32,
    "slugLong": "/danismanliklar/isim-icin/kariyerim-icin/insan-kaynaklari/",
    "slug": "/insan-kaynaklari/",
    "level": 3,
    "keywords": "İnsan Kaynakları Uzmanı, Online İnsan Kaynakları"
  },
  "sgk-eyt-uzmani": {
    "id": 757112,
    "title": "SGK/EYT Uzmanı\t",
    "description": "Sosyal güvenlik ve EYT konusunda sizlere yardımcı olarak uzmanlarımızdan online görüşme için randevu alabilirsiniz",
    "metaTitle": "Online SGK/EYT Uzmanlığı",
    "metaDescription": "Sosyal güvenlik ve EYT konusunda sizlere yardımcı olarak uzmanlarımızdan online görüşme için randevu alabilirsiniz",
    "imgUrl": "/category-images/sgk-eyt.png",
    "parentId": 32,
    "slugLong": "/danismanliklar/isim-icin/kariyerim-icin/sgk-eyt-uzmani/",
    "slug": "/sgk-eyt-uzmani/",
    "level": 3,
    "keywords": "SGK uzmanı, EYT uzmanı, Sosyal Güvenlik uzmanı"
  }
}

export const slugLongMap: string[] = [
  "/online-psikolog/",
  "/aile-danismanligi/",
  "/cinsel-terapi/",
  "/butunsel-terapi/",
  "/yasam-kocu/",
  "/diyetisyen/",
  "/spor/",
  "/stil/",
  "/fizyoterapi/",
  "/astroloji/",
  "/numeroloji/",
  "/nlp/",
  "/reiki-enerji/",
  "/ailedizimi/",
  "/human-design/",
  "/kozmik-enerji/",
  "/theta-healing/",
  "/mindfulness/",
  "/jaas/",
  "/cocuk-psikologu/",
  "/cocuk-gelisim/",
  "/ogrenci-kocu/",
  "/rehberlik/",
  "/diyetisyen-kids/",
  "/uyku-danismanligi/",
  "/emzirme-danismanligi/",
  "/ebeveyn-danismanligi/",
  "/girisim/",
  "/sosyal-medya/",
  "/eticaret/",
  "/muhasebe/",
  "/pazarlama/",
  "/is-gelistirme/",
  "/satis/",
  "/tasarim/",
  "/profesyonel-koc/",
  "/hikaye-anlaticiligi/",
  "/insan-kaynaklari/",
  "/sgk-eyt-uzmani/"
]